import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { DataContext } from "../../../App";
import Select from "react-select";
import { AddItem, GetById, UpdateItem } from "../../../utils/functions";
import TextField from "../../../components/input/fields/text-field";
import TagsInput from "../../../components/input/tags/tags-input";
import { toast } from "react-toastify";
import Uploader from "../../../components/Uploader/Uploader";
import { useTranslation } from "react-i18next";
import { Checkbox } from "primereact/checkbox";
import { Editor } from 'primereact/editor';
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UnitFieldSymbols } from "../../../components/input/fields/input-with-symbols";
import { Tab, Typography, Box } from "@mui/material";
import { TabContext, TabList } from "@mui/lab";
import { NavLink } from "react-router-dom";
import LoadingApp from "../../../components/loadingApp/loadingApp";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const Manage = (item) => {
  const context = useContext(DataContext);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const Id = (item["id"] ?? null);
  const [properties, setProperties] = useState(null);
  const [valueTab, setValueTab] = useState(0);
  const [carouselDisplay, setCarouselDisplay] = useState(false);
  const [isBtnDisable, setIsBtnDisable] = useState(false);

  const [isMobileTablet, setIsMobileTablet] = useState(window.matchMedia("(max-width: 991px)").matches);
  //OPTIONS
  const optionsPropertyType = [
    {
      label: t("Basic"),
      value: "basic",
    },
    {
      label: t("Premium"),
      value: "premium",
    }
  ];

  const optionsPropertyStatus = [
    {
      label: t("Active"),
      value: "active",
    },
    {
      label: t("Inactive"),
      value: "inactive",
    },
  ];
  const optionsPropertyCategory = [
    {
      label: t("Villa"),
      value: "villa",
    },
    {
      label: t("Apartment"),
      value: "apartment",
    },
  ];


  const initialAmenities = {
    //Start Amenities utils to filter in the property collection
    PrivatePool: false,
    HeatedPool: false,
    AirCon: false,
    HotTub: false,
    Jacuzzi: false,
    WeddingVenue: false,
    Wifi: false,
    SeaView: false,
    WalkToBeach: false,
    WalkToVillage: false,
    // End Amenities utils to filter in the property collection
    AirConditioning: false,
    Parking: false,
    Pool: false,
    Gym: false,
    Kitchen: false,
    Tv: false,
    Washer: false,
    Dryer: false,
    FreeParkingPremises: false,
    FreeParkingStreet: false,
    OutdoorPool: false,
    Heating: false,
    BBQGrill: false,
    CoffeeMaker: false,
    LaptopWorkspace: false,
    HairDryer: false,
    Iron: false,
    CableTv: false,
    Essentials: false,
    Refrigerator: false,
    FirstAidKit: false,
    Shampoo: false,
    Hangers: false,
    FireExtinguisher: false,
    PrivateEntrance: false,
    KidFriendly: false,
    BedLinens: false,
    HighChair: false,
    CourtesySet: false,
    Microwave: false,
    Dishwasher: false,
    Oven: false,
    Patio: false,
    DishesSilverware: false,
    Stove: false,
    Backyard: false,
    Cookware: false,
  }

  const selectedTags = (tags) => {
    const newKeywords = [...tags];
    setFormValues((prevValues) => ({
      ...prevValues,
      seoInformation: {
        ...prevValues.seoInformation,
        keywords: newKeywords
      }
    }));
  };

  const [formValues, setFormValues] = useState({
    id: Id,
    idGuesty: null,
    name: null,
    typology: null,
    category: null,
    status: null,
    guests: null,
    beds: null,
    bedrooms: null,
    bathrooms: null,
    isCarouselDisplay: carouselDisplay,
    address: {
      area: null,
      city: null,
    },
    seoInformation: null,
    villa: {
      description: null,
      images: null,
    },
    intro: null,
    rooms: null,
    arrivalsAndDeparture: null,
    touristsTax: null,
    servicesWithAdditionalCharge: null,
    theArea: null,
    brochure: null,
    amenities: initialAmenities,
    gallery: [],
  });
  

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleNumericChange = (propertyName) => (value) => {
    setFormValues((prevState) => ({
      ...prevState,
      [propertyName]: value.target.value,
    }));
  };

  const handleChange = (event, newValue) => {
    setValueTab(newValue);
  };

  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevState) => ({
      ...prevState,
      address: {
        ...prevState.address,
        [name]: value,
      },
    }));
  };

  const areAllSelected = () => Object.values(formValues.amenities).every((value) => value);

  const handleSelectAll = () => {
    const allSelected = Object.keys(initialAmenities).reduce((acc, key) => {
      acc[key] = true;
      return acc;
    }, {});
    setFormValues((prevValues) => ({
      ...prevValues,
      amenities: allSelected,
    }));
  };

  const handleDeselectAll = () => {
    setFormValues((prevValues) => ({
      ...prevValues,
      amenities: initialAmenities,
    }));
  };

  const handleAmenityChange = (e) => {
    const { name, checked } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      amenities: {
        ...prevValues.amenities,
        [name]: checked,
      },
    }));
  };

  const handleImage = (filePaths, section) => {
    setFormValues((prevValues) => {
      const updatedValues = { ...prevValues };
      if (section === "villa") {
        updatedValues[section] = {
          ...updatedValues[section],
          images: filePaths,
        };
      } else if(section === "brochure"){
        updatedValues[section] = [filePaths[filePaths.length - 1]];
      }else {
        updatedValues[section] = filePaths;
      }
  
      return updatedValues;
    });
  };

  const handleRemoveImage = (index, section) => {
    setFormValues((prevValues) => {
      
      const updatedValues = { ...prevValues };
      if (section === "villa") {
        updatedValues[section].images = updatedValues.villa?.images.filter(
          (_, i) => i !== index
        );
      } else {
        updatedValues[section] = updatedValues[section]?.filter((_, i) => i !== index);
      }
      return updatedValues;
    });
  };

  const handleMoveImage = (sourceIndex, destinationIndex, section) => {
    setFormValues((prevValues) => {
      const updatedValues = { ...prevValues };
      const images = [...(section === "villa" ? updatedValues[section].images : updatedValues[section])];
  
      const [movedImage] = images.splice(sourceIndex, 1);
      images.splice(destinationIndex, 0, movedImage);
  
      if (section === "villa") {
        updatedValues[section].images = images;
      } else {
        updatedValues[section] = images;
      }
  
      return updatedValues;
    });
  };

  const checkValues = () => {

    if (!formValues.name) {
      toast.error(t("ToastErrorNameRequired"));
      return false;
    }

    if (!formValues.typology) {
      toast.error(t("ToastErrorTypologyRequired"));
      return false;
    }

    if (!formValues.category) {
      toast.error(t("ToastErrorCategoryRequired"));
      return false;
    }

    if (formValues.status === null) {
      toast.error(t("ToastErrorStatusRequired"));
      return false;
    }

    if (!formValues.guests || formValues.guests === 0) {
      toast.error(t("ToastErrorGuestsRequired"));
      return false;
    }

    if (formValues.isCarouselDisplay === null) {
      toast.error(t("ToastErrorCarouselDisplayRequired"));
      return false;
    }

    if (!formValues.address.city) {
      toast.error(t("ToastErrorCityIsRequired"));
      return false;
    }

    if (!formValues.address.area) {
      toast.error(t("ToastErrorAreaIsRequired"));
      return false;
    }

    if (!formValues.seoInformation.title) {
      toast.error(t("ToastErrorTitleSeoRequired"));
      return false;
    }

    if (!formValues.seoInformation.linkUrl) {
      toast.error(t("ToastErrorLinkUrlSeoRequired"));
      return false;
    }

    return true;
  };

  const handleSelectChange = (propertyName) => (selectedOption) => {
    setFormValues((prevState) => ({
      ...prevState,
      [propertyName]: selectedOption ? selectedOption.value : null,
    }));
  };

  const handleSubmit = async (e) => {

    e.preventDefault();
    setIsBtnDisable(true);

    try {
      if (checkValues()) {
        let resp = null;

        const selectedAmenities = formValues.amenities && Object.entries(formValues.amenities)
          .filter(([_, value]) => value && value !== "null")
          .map(([key, _]) => key);

        const propertyData = {
          ...formValues,
          amenities: selectedAmenities ?? null,
          address: {
            area: formValues.address.area.trim(),
            city: formValues.address.city.trim()
          }
        };

        if (Id) {
          resp = await UpdateItem('Property', propertyData);
        } else {
          resp = await AddItem('Property', propertyData);
        }

        if (resp) {
          await context.updateData("properties-collection");
          navigate("/admin/properties-collection")
        }
      }
    } catch (error) {
      toast.error(t('ErrorProperty'));
    }

    setIsBtnDisable(false);
  }

  useEffect(() => {
    const fetchProperties = async () => {
      if (!properties && Id) {
        const data = await GetById("Property", Id);
        if (data) {
          setProperties(data);
        }
      }
    };
    fetchProperties();
    // eslint-disable-next-line
  }, []);
  
  useEffect(() => {
    if (properties) {
      const updatedAmenities = { ...initialAmenities };

      if (properties.amenities) {
        properties.amenities.forEach((amenity) => {
          if (updatedAmenities.hasOwnProperty(amenity)) {
            updatedAmenities[amenity] = true;
          }
        });
      }

      setFormValues({
        id: Id,
        idGuesty: properties.idGuesty ?? null,
        name: properties.name ?? null,
        typology: properties.typology ?? null,
        category: properties.category ?? null,
        status: properties.status ?? null,
        guests: properties.guests ?? null,
        beds: properties.beds ?? null,
        bedrooms: properties.bedrooms ?? null,
        bathrooms: properties.bathrooms ?? null,
        isCarouselDisplay: properties.isCarouselDisplay ?? carouselDisplay,
        address: properties.address ?? { area: null, city: null },
        seoInformation: properties.seoInformation ?? null,
        villa: properties.villa
          ? {
              description: properties.villa.description,
              images: properties.villa.images,
            }
          : { description: null, images: null },
        intro: properties.intro ?? null,
        rooms: properties.rooms ?? null,
        arrivalsAndDeparture: properties.arrivalsAndDeparture ?? null,
        touristsTax: properties.touristsTax ?? null,
        servicesWithAdditionalCharge: properties.servicesWithAdditionalCharge ?? null,
        theArea: properties.theArea ?? null,
        brochure: properties.brochure ? properties.brochure : null,
        amenities: updatedAmenities,
        gallery: properties.gallery ? properties.gallery : [],
      });
    }
  }, [properties]); 

  if (!properties && Id) {
    return  <LoadingApp />;
  }

  return (
    <section className="mt-5 container-admin">
      <div className="row">
        <NavLink className="come-back-admin" to={"/admin/properties-collection"}>
          <FontAwesomeIcon icon={faAngleLeft} />
          {t("Back")}
        </NavLink>
        <div className="row mt-5 mb-5">
          <div className="mb-5">
            <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
              {t("GeneralInformations")}
            </h5>
            <p>{t("PropertyGeneralInformations")}</p>

          </div>
          <div className="flex-wrap col-lg-4 col-12 my-3">
            <div className="d-flex flex-column">
              <label
                className={`ms-1 fs-6 text-black w-full mb-2`}
              >
                {t("IdGuesty")}
              </label>
              <TextField
                id={"id-guesty"}
                name={"idGuesty"}
                type={"text"}
                placeholder={t("Insert")}
                onChange={handleInputChange}
                inputClassName={"grey-input w-100"}
                value={formValues.idGuesty}
              />
            </div>
          </div>
          <div className="flex-wrap col-lg-4 col-12 my-3">
            <div className="d-flex flex-column">
              <TextField
                id={"name"}
                name={"name"}
                label={t("PropertyName")}
                type={"text"}
                inputClassName={"grey-input w-100"}
                placeholder={t("Insert")}
                onChange={handleInputChange}
                value={formValues.name}
                isRequired={true}
              />
            </div>
          </div>
          <div className="flex-wrap col-lg-2 col-12 my-3">
            <div className="d-flex flex-column">
              <label
                className={`ms-1 fs-6 text-black w-full mb-2`}
              >
                {t("Typology")}<span className="text-danger">*</span>
              </label>
              <Select
                options={optionsPropertyType}
                placeholder={t("Select")}
                className="grey-select"
                onChange={handleSelectChange("typology")}
                isSearchable={false}
                value={optionsPropertyType.find(
                  (option) => option.value === formValues.typology
                )}
              />
            </div>
          </div>
          <div className="flex-wrap col-lg-2 col-12 my-3">
            <div className="d-flex flex-column">
              <label
                className={`ms-1 fs-6 text-black w-full mb-2`}
              >
                {t("Category")}<span className="text-danger">*</span>
              </label>
              <Select
                options={optionsPropertyCategory}
                placeholder={t("Select")}
                className="grey-select"
                isSearchable={false}
                onChange={handleSelectChange("category")}
                value={optionsPropertyCategory.find(
                  (option) => option.value === formValues.category
                )}
              />
            </div>
          </div>
          <div className="flex-wrap col-lg-2 col-12 my-3">
            <div className="d-flex flex-column">
              <label
                className={`ms-1 fs-6 text-black w-full mb-2`}
              >
                {t("Status")}<span className="text-danger">*</span>
              </label>
              <Select
                options={optionsPropertyStatus}
                placeholder={t("Select")}
                className="grey-select"
                isSearchable={false}
                onChange={handleSelectChange("status")}
                value={optionsPropertyStatus.find(
                  (option) => option.value === formValues.status
                )}
              />
            </div>
          </div>

          <div className="flex-wrap col-lg-2 col-md-3 col-sm-4 col-12 my-3">
            <div className="d-flex flex-column">
              <UnitFieldSymbols
                key={formValues.guests}
                label={t("Guests")}
                value={formValues.guests}
                className={"grey-number-input px-2 py-1 w-100"}
                inputClassName={"grey-number-input"}
                onChange={handleNumericChange("guests")}
                isRequired={true}
              ></UnitFieldSymbols>
            </div>
          </div>
          <div className="flex-wrap col-lg-2 col-md-3 col-sm-4 col-12 my-3">
            <div className="d-flex flex-column">
              <UnitFieldSymbols
                key={formValues.beds}
                label={t("Beds")}
                value={formValues.beds}
                className={"grey-number-input px-2 py-1 w-100"}
                inputClassName={"grey-number-input"}
                onChange={handleNumericChange("beds")}
                isRequired={true}
              ></UnitFieldSymbols>
            </div>
          </div>
          <div className="flex-wrap col-lg-2 col-md-3 col-sm-4 col-12 my-3">
            <div className="d-flex flex-column">
              <UnitFieldSymbols
                key={formValues.bedrooms}
                label={t("Bedrooms")}
                value={formValues.bedrooms}
                className={"grey-number-input px-2 py-1 w-100"}
                inputClassName={"grey-number-input"}
                onChange={handleNumericChange("bedrooms")}
                isRequired={true}
              ></UnitFieldSymbols>
            </div>
          </div>
          <div className="flex-wrap col-lg-2 col-md-3 col-sm-4 col-12 my-3">
            <div className="d-flex flex-column">
              <UnitFieldSymbols
                key={formValues.bathrooms}
                label={t("Bathrooms")}
                value={formValues.bathrooms}
                className={"grey-number-input px-2 py-1 w-100"}
                inputClassName={"grey-number-input"}
                onChange={handleNumericChange("bathrooms")}
                isRequired={true}
              ></UnitFieldSymbols>
            </div>
          </div>
          <div className="d-flex col-12 mt-3">
            <label
              className={`ms-1 fs-6 text-black w-full mr-10`}
            >
              {t("CarouselDisplay")}<span className="text-danger">*</span>
            </label>
            <div className="d-flex justify-content-start">
              <label className="flex-wrap mr-10">
                <Checkbox
                  onChange={handleAmenityChange}
                  onClick={() => {
                    setCarouselDisplay(true);
                    setFormValues((prevValues) => ({
                      ...prevValues,
                      isCarouselDisplay: true
                    }))
                  }}
                  className={"checkbox-admin me-1"}
                  checked={carouselDisplay}
                />
                <span className="ms-1">{t("Yes")}</span>
              </label>
              <label className="flex-wrap">
                <Checkbox
                  onClick={() => {
                    setCarouselDisplay(false);
                    setFormValues((prevValues) => ({
                      ...prevValues,
                      isCarouselDisplay: false
                    }))
                  }}
                  className={"checkbox-admin me-1"}
                  checked={!carouselDisplay}
                />
                <span className="ms-1">{t("No")}</span>
              </label>
            </div>
          </div>
        </div>
        <hr />
        <div className="row mt-2 mb-5">
          <h5 className="mt-3 text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
            {t("AddressInformation")}
          </h5>
          <div className="flex-wrap col-lg-4 col-12 my-3">
            <div className="d-flex flex-column">
              <TextField
                id={"city"}
                name={"city"}
                label={t("City")}
                type={"text"}
                placeholder={t("Insert")}
                onChange={handleAddressChange}
                inputClassName={"grey-input w-100"}
                value={formValues.address.city}
                isRequired={true}
              />
            </div>
          </div>
          <div className="flex-wrap col-lg-4 col-12 my-3">
            <div className="d-flex flex-column">
              <TextField
                id={"area"}
                name={"area"}
                label={t("Area")}
                type={"text"}
                placeholder={t("Insert")}
                onChange={handleAddressChange}
                inputClassName={"grey-input w-100"}
                value={formValues.address.area}
                isRequired={true}
              />
            </div>
          </div>
        </div>
        <hr />
        <div className="row mt-2 mb-5">
          <div className="mb-5">
            <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
              {t("Seo")}
            </h5>
            <p>{t("ExperiencesSeoInformations")}</p>
          </div>
          <div className="flex-wrap col-lg-6 col-12 my-3">
            <div className="d-flex flex-column position-relative">
              <label
                className={`ms-1 fs-6 text-black w-full mb-2`}
              >
                {t("Title")}<span className="text-danger">*</span>
              </label>
              <textarea
                maxLength={60}
                value={formValues.seoInformation?.title}
                className="grey-input w-100 min-h-100px"
                placeholder={t("Insert")}
                onChange={(e) =>
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    seoInformation: {
                      ...prevValues.seoInformation,
                      title: e.target.value,
                    },
                  }))
                }
              ></textarea>
              <p className="paragraph position-absolute end-0 top-100 font-description-small">
                {t("Max60")}
              </p>
            </div>
          </div>
          <div className="flex-wrap col-lg-6 col-12 my-3">
            <div className="d-flex flex-column position-relative">
              <label
                className={`ms-1 fs-6 text-black w-full mb-2`}
              >
                {t("MetaDescription")}
              </label>
              <textarea
                maxLength={160}
                value={formValues.seoInformation?.metaDescription}
                className="grey-input w-100 min-h-100px"
                placeholder={t("Insert")}
                onChange={(e) =>
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    seoInformation: {
                      ...prevValues.seoInformation,
                      metaDescription: e.target.value,
                    },
                  }))
                }
              ></textarea>
              <p className="paragraph position-absolute end-0 top-100 font-description-small ">
                {t("Max160")}
              </p>
            </div>
          </div>
          <div className="flex-wrap col-lg-6 col-12 my-3">
            <div className="d-flex flex-column position-relative">
              <TextField
                id={"LinkUrl"}
                name={"LinkUrl"}
                label={t("LinkUrl")}
                type={"text"}
                inputClassName={"grey-input w-100"}
                placeholder={t("Insert")}
                isRequired={true}
                onChange={(e) =>
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    seoInformation: {
                      ...prevValues.seoInformation,
                      linkUrl: e.target.value,
                    },
                  }))
                }
                value={formValues.seoInformation?.linkUrl}
              />
            </div>
          </div>
          <div className="flex-wrap col-lg-6 col-12 my-3">
            <TagsInput
              key={formValues.seoInformation?.keywords?.join(",")}
              label={t("Keywords")}
              placeholder={t("KeywordsPlaceholder")}
              selectedTags={selectedTags}
              defaultTags={formValues.seoInformation?.keywords ?? []}
            />
          </div>
        </div>
        <hr />
        <div className="row mt-2 mb-5 custom-mb-responsive">
          <div className="mb-5">
            <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
              {t("VillaDetails")}
            </h5>
            <p>{t("VillaDetailsDescription")}</p>
          </div>
          <TabContext value={valueTab} className="d-flex mt-5 pt-5">
            <TabList
              orientation="horizontal"
              centered={false}
              onChange={handleChange}
              aria-label=""
              className="custom-tabs-property c mb-4"
              variant="standard"
              TabIndicatorProps={{ style: { display: 'none' } }}
              sx={{
                '& .MuiTabs-flexContainer': {
                  flexWrap: 'wrap',
                  justifyContent: 'left'
                },
                '& .MuiTab-root': {
                  position: 'relative',
                  textAlign: 'left',
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    left: 0,
                    bottom: 0,
                    height: '2px',
                    width: 0,
                    backgroundColor: '#000',
                    transition: 'width 0.3s ease-in-out',
                  },
                },
                '& .Mui-selected::after': {
                  width: '100%',
                },
                '@media (max-width: 767px)': {
                  '& .MuiTab-root': {
                    width: '100%',
                    justifyContent: 'flex-start',
                    textAlign: 'left',
                    marginBottom: '5px' 
                  },
                  '& .Mui-selected::after': {
                    width: '0',
                  },
                },
              }}
            >
              <Tab
                value={0}
                label={t("IntroDescription")}
                className="text-black mx-3"
                wrapped
              />
              <Tab
                value={1}
                label={t("VillaDescriptionFloorPlan")}
                className="text-black text-center mx-3"
                wrapped
              />
              <Tab
                value={2}
                label={t("RoomsDescription")}
                className="text-black text-center mx-3"
                wrapped
              />
              <Tab
                value={3}
                label={t("ArrivalAndDeparture")}
                className="text-black text-center mx-3"
                wrapped
              />
              <Tab
                value={4}
                label={t("TouristTax")}
                className="text-black text-center mx-3"
                wrapped
              />
              <Tab
                value={5}
                label={t("ServicesWithAdditionalCharge")}
                className="text-black text-center mx-3"
                wrapped
              />
              <Tab
                value={6}
                label={t("TheArea")}
                className="text-black text-center mx-3"
                wrapped
              />
              <Tab
                value={7}
                label={t("AddBrochure")}
                className="text-black text-center mx-3"
                wrapped
              />
            </TabList>
            <div className="col-12">
              <TabPanel
                value={valueTab}
                index={0}
                className="custom-panels-admin-area"
              >
                <Editor
                  value={formValues.intro}
                  onTextChange={(e) => {
                    setFormValues((prevValues) => ({
                      ...prevValues,
                      intro: e.htmlValue
                    }))
                  }}                  
                  placeholder={t("Insert")}
                  className={`w-100 mb-2 ${!isMobileTablet ? "h-150" : ""}`}
                />
              </TabPanel>
              <TabPanel
                value={valueTab}
                index={1}
                className="custom-panels-admin-area pe-2"
                keepMounted
              >
                <div className="overflow-auto d-flex flex-wrap">
                  <div className="col-12">
                    <Editor
                      value={formValues.villa?.description}
                      onTextChange={(e) => {
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          villa: {
                            ...prevValues.villa,
                            description: e.htmlValue,
                          },
                        }))
                      }}
                      placeholder={t("Insert")}
                      className={`w-100 mb-2 ${!isMobileTablet ? "h-150" : ""}`}
                    />
                  </div>
                  <div className="col-12">
                    <Uploader
                      value={formValues.villa?.images ?? []}
                      onChange={(files) => handleImage(files, "villa")}
                      onRemove={(index) => handleRemoveImage(index, "villa")}
                      onMove={(sourceIndex, destinationIndex) => handleMoveImage(sourceIndex, destinationIndex, "villa")}
                    />
                  </div>
                </div>
              </TabPanel>
              <TabPanel
                value={valueTab}
                index={2}
                className="custom-panels-admin-area"
              >
                <Editor
                  value={formValues.rooms}
                  onTextChange={(e) => {
                    setFormValues((prevValues) => ({
                      ...prevValues,
                      rooms: e.htmlValue,
                    }))
                  }}
                  placeholder={t("Insert")}
                  className={`w-100 mb-2 ${!isMobileTablet ? "h-150" : ""}`}
                />
              </TabPanel>
              <TabPanel
                value={valueTab}
                index={3}
                className="custom-panels-admin-area"
              >
                <Editor
                  value={formValues.arrivalsAndDeparture}
                  onTextChange={(e) => {
                    setFormValues((prevValues) => ({
                      ...prevValues,
                      arrivalsAndDeparture: e.htmlValue,
                    }))
                  }}
                  placeholder={t("Insert")}
                  className={`w-100 mb-2 ${!isMobileTablet ? "h-150" : ""}`}
                />
              </TabPanel>
              <TabPanel
                value={valueTab}
                index={4}
                className="custom-panels-admin-area"
              >
                <Editor
                  value={formValues.touristsTax}
                  onTextChange={(e) => {
                    setFormValues((prevValues) => ({
                      ...prevValues,
                      touristsTax: e.htmlValue,
                    }))
                  }}
                  placeholder={t("Insert")}
                  className={`w-100 mb-2 ${!isMobileTablet ? "h-150" : ""}`}
                />
              </TabPanel>
              <TabPanel
                value={valueTab}
                index={5}
                className="custom-panels-admin-area"
              >
                <Editor
                  value={formValues.servicesWithAdditionalCharge}
                  onTextChange={(e) => {
                    setFormValues((prevValues) => ({
                      ...prevValues,
                      servicesWithAdditionalCharge: e.htmlValue,
                    }))
                  }}
                  placeholder={t("Insert")}
                  className={`w-100 mb-2 ${!isMobileTablet ? "h-150" : ""}`}
                />
              </TabPanel>
              <TabPanel
                value={valueTab}
                index={6}
                className="custom-panels-admin-area"
              >
                <Editor
                  value={formValues.theArea}
                  onTextChange={(e) => {
                    setFormValues((prevValues) => ({
                      ...prevValues,
                      theArea: e.htmlValue,
                    }))
                  }}
                  placeholder={t("Insert")}
                  className={`w-100 mb-2 ${!isMobileTablet ? "h-150" : ""}`}
                />
              </TabPanel>
              <TabPanel
                value={valueTab}
                index={7}
                className="custom-panels-admin-area"
              >
                <Uploader
                  fileType={".pdf"}
                  value={formValues.brochure ?? []}
                  onChange={(files) => handleImage(files, "brochure")}
                  onRemove={(index) => handleRemoveImage(index, "brochure")}
                  onMove={(sourceIndex, destinationIndex) => handleMoveImage(sourceIndex, destinationIndex, "brochure")}
                />
              </TabPanel>
            </div>
          </TabContext>
        </div>
        <hr />
        <div className="row mt-2 mb-5">
          <div className="mb-5">
            <div className="d-flex justify-content-between">
              <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
                {t("Amenities")}
              </h5>
              <div className="d-flex justify-content-end">
                <button
                  onClick={handleSelectAll}
                  className="background-white text-black me-2 border-none d-flex align-items-center"
                >
                  <Checkbox checked={areAllSelected()} className="checkbox-admin me-1" />
                  {t("SelectAll")}
                </button>
                <button
                  onClick={handleDeselectAll}
                  className="background-white text-black me-2 border-none d-flex align-items-center"
                >
                  <Checkbox checked={!areAllSelected()} className="checkbox-admin me-1" />
                  {t("DeselectAll")}
                </button>
              </div>
            </div>

          </div>
          <div className="mb-2">
            <div className="d-flex flex-wrap gap-2">
              {formValues.amenities && Object.entries(formValues.amenities).map(([key, value]) => (
                <label
                  key={key}
                  className={`m-1 checkbox-btn ${value ? "checked" : ""}`}
                >
                  <Checkbox
                    name={key}
                    checked={value}
                    onChange={handleAmenityChange}
                    className="d-none"
                  />
                  <span>{key !== null ? t(key) : ""}</span>
                </label>
              ))}
            </div>
          </div>
        </div>
        <hr />
        <div className="row mt-2 mb-5">
          <div className="d-flex flex-column">
            <div className="mb-5">
              <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
                {t("GalleryImages")}
              </h5>
              <p>{t("RecommendedSizeVillaDescription")}</p>
            </div>
              <Uploader
                value={formValues.gallery ?? []}
                onChange={(files) => handleImage(files, "gallery")}
                onRemove={(index) => handleRemoveImage(index, "gallery")}
                onMove={(sourceIndex, destinationIndex) => handleMoveImage(sourceIndex, destinationIndex, "gallery")}
                isFullWidth
              />
          </div>

        </div>
        <div className="d-flex justify-content-end">
          <div className="mt-5">
            <button
              onClick={handleSubmit}
              disabled={isBtnDisable}
              className="admin-button border-none text-uppercase">
              {Id !== null ? t("Update") : t("Create")}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Manage;
